import { Component, OnInit, Input, HostBinding } from '@angular/core';

/**
 * A Government of Alberta styled button.
 * selector: button[goab-button], input[type="button"][goab-button], input[type="submit"][goab-button]
 */
@Component({
  standalone: false,
  selector: 'button[goab-button], input[type="button"][goab-button], input[type="submit"][goab-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class GoAButtonComponent implements OnInit {
  /**
   * Adds class goab-button to the host.
   * @ignore
   */
  @HostBinding('class.goab-button') get buttonBinding() {
    return true;
  }

  /**
   * Adds class destructive to the host if destructive = true.
   * @ignore
   */
  @HostBinding('class.destructive') get destructiveBinding() {
    return this.destructive;
  }

  /**
   * Adds class goab--primary to the host if the buttonStyle = primary.
   * @ignore
   */
  @HostBinding('class.primary') get primaryBinding() {
    return this.buttonType === 'primary';
  }

  /**
   * Adds class goab--submit to the host if the buttonStyle = submit.
   * @ignore
   */
  @HostBinding('class.submit') get submitBinding() {
    return this.buttonType === 'submit';
  }

  /**
   * Adds class goab--start to the host if the buttonStyle = start.
   * @ignore
   */
  @HostBinding('class.start') get startBinding() {
    return this.buttonType === 'start';
  }

  /**
   * Adds class goab--secondary to the host if the buttonStyle = secondary.
   * @ignore
   */
  @HostBinding('class.secondary') get secondaryBinding() {
    return this.buttonType === 'secondary';
  }

  /**
   * Adds class goab--tertiary to the host if the buttonStyle = tertiary.
   * @ignore
   */
  @HostBinding('class.tertiary') get tertiaryBinding() {
    return this.buttonType === 'tertiary';
  }

  /**
   * Adds class btn-small to the host if the buttonSize = small.
   * @ignore
   */
  @HostBinding('class.compact') get smallBinding() {
    return this.buttonSize === 'small';
  }

  /**
   * Is the button destructive
   */
  @Input() destructive = false;

  /**
   * The appearance style of the button.
   */
  @Input() buttonType: 'primary' | 'secondary' | 'tertiary' | 'submit' | 'start' = 'primary';

  /**
   * The size of the button, controls font size and padding.
   */
  @Input() buttonSize: 'small' | 'normal' = 'normal';

  constructor() {}

  /**
   * @ignore
   */
  ngOnInit() {}
}
